import React, {useState} from 'react'
import {Button} from '@thryvlabs/maverick'
import {useAuthClient} from '../utils/use-auth-client'
import {toast} from 'react-toastify'

function RefreshArrowsIcon({size = 14, color = 'rgba(128,128,128)'}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <polyline points="23 4 23 10 17 10" />
      <polyline points="1 20 1 14 7 14" />
      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
    </svg>
  )
}

function RefreshProductsCacheButton({
  windowWidth,
  isSidebarOpen,
  isMobileSidebarOpen,
}) {
  const client = useAuthClient()
  const [isLoading, setIsLoading] = useState(false)

  const handleRefresh = async () => {
    if (isLoading) return
    setIsLoading(true)
    try {
      await client('plans/5/v1/list/refresh')
      toast.success('Products cache refreshed successfully.')
    } catch (error) {
      toast.error(error.message || 'Failed to refresh products cache.')
    } finally {
      setIsLoading(false)
    }
  }

  const isExpanded = windowWidth > 835 ? isSidebarOpen : isMobileSidebarOpen

  const recycleIcon = (
    <span
      style={{
        display: 'inline-flex',
        animation: isLoading ? 'spin 1s linear infinite' : 'none',
      }}
    >
      <RefreshArrowsIcon />
    </span>
  )

  if (!isExpanded) {
    return (
      <button
        onClick={handleRefresh}
        disabled={isLoading}
        title="Refresh Products Cache"
        style={{
          background: 'none',
          border: 'none',
          cursor: isLoading ? 'not-allowed' : 'pointer',
          padding: '4px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {recycleIcon}
      </button>
    )
  }

  return (
    <Button
      variant="secondary"
      onClick={handleRefresh}
      disabled={isLoading}
      style={{width: '100%', marginTop: '5px'}}
    >
      <span
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '6px',
        }}
      >
        {recycleIcon}
        {isLoading ? 'Refreshing...' : 'Refresh Products Cache'}
      </span>
    </Button>
  )
}

export {RefreshProductsCacheButton}
